<template>
  <v-card flat>
    <v-card-title class="title font-weigth-light px-0 py-0 mb-4">
      Key Vehicle Allocation
    </v-card-title>
    <v-card-text class="px-0">
      <v-row>
        <v-col cols="6">
          <v-combobox
            v-model="selectedCabinet"
            :items="cabinets"
            item-text="name"
            item-value="id"
            label="Cabinet"
            multiple
            outlined
            required
            @change="checkAllCabinet(false)"
          >
            <template #prepend-item>
              <v-list-item
                ripple
                @click="checkAllCabinet(true)"
              >
                <v-list-item-action class="mr-3">
                  <v-icon>{{ iconCheckAllCabinet }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ textCheckAllCabinet }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2" />
            </template>
            <template #selection="{ item, index }">
              <v-chip v-if="index === 0">
                <span>{{ item.name }}</span>
              </v-chip>
              <span
                v-if="index === 1"
                class="grey--text caption"
              >
                (+{{ selectedCabinet.length - 1 }} Others)
              </span>
            </template>
          </v-combobox>
        </v-col>
        <v-col cols="6">
          <v-combobox
            v-model="selectedCabinetItem"
            :items="cabinetItems"
            item-text="text"
            item-value="value"
            label="Cabinet Item No."
            multiple
            outlined
            required
            @change="checkAllCabinetItem(false)"
          >
            <template #prepend-item>
              <v-list-item
                ripple
                @click="checkAllCabinetItem(true)"
              >
                <v-list-item-action class="mr-3">
                  <v-icon>{{ iconCheckAllCabinetItem }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ textCheckAllCabinetItem }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2" />
            </template>
            <template #selection="{ item, index }">
              <v-chip v-if="index === 0">
                <span>{{ item.text }}</span>
              </v-chip>
              <span
                v-if="index === 1"
                class="grey--text caption"
              >
                (+{{ selectedCabinetItem.length - 1 }} Others)
              </span>
            </template>
          </v-combobox>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          class="py-0 d-flex justify-end"
        >
          <v-btn
            border
            color="primary"
            @click="generateReport"
          >
            Generate
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-if="isGenerate && dataPerTab.length">
        <v-col cols="12">
          <v-tabs
            bg-color="primary"
          >
            <v-tab
              v-for="tab in selectedCabinetForTabs"
              :key="tab.id"
              :value="tab.id"
              @click="generateReport(tab.id)"
              :ref="`tab-${tab.id}`"
            >
              {{ tab.name }}
            </v-tab>
          </v-tabs>
          <v-data-table
            :headers="headers"
            :items="dataPerTab"
            class="font-weight-light pa-5"
            :loading="isLoading"
            loading-text="Loading"
            :footer-props="footerProps"
            :options.sync="paginationOptions"
          />
        </v-col>
      </v-row>
      <v-row v-if="isLoading">
        <v-col cols="12">
          <p class="text-center">
            Loading
          </p>
        </v-col>
      </v-row>
      <v-row v-if="isGenerate && !isLoading && dataPerTab.length === 0">
        <v-col cols="12">
          <p class="text-center">
            No Data Found
          </p>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      assets: [],
      vehicles: [],
      cabinets: [],
      selectedCabinet: [],
      selectedCabinetForTabs: [],
      selectedCabinetItem: [],
      selectedCabinetTab: '',
      headers: [
        { text: 'Cabinet', value: 'cabinet.name'},
        { text: 'Cabinet Item No.', value: 'item.number' },
        { text: 'Asset Type', value: 'asset_type' },
        { text: 'Asset Name', value: 'asset_name' },
      ],
      footerProps: {
        itemsPerPageOptions: [2, 3, 5, 10, 20, 50, 100, 200, 500]
      },
      paginationOptions: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: []
      },
      data: [],
      isLoading: false,
      isGenerate: false,
      textCheckAllCabinet: 'CHECK ALL CABINET',
      iconCheckAllCabinet: 'mdi-check-all',
      textCheckAllCabinetItem: 'CHECK ALL CABINET ITEM',
      iconCheckAllCabinetItem: 'mdi-check-all',
    };
  },
  props: {
    params: {
      type: Object,
      required: false,
      default: () => ({
        cabinets: [],
        assets: [],
        vehicles: [],
      }),
    },
  },
  mounted() {
    this.cabinets = this.params.cabinets;
    this.assets = this.params.assets;
    this.vehicles = this.params.vehicles;
  },
  computed: {
    cabinetItems() {
      const selectedCabinet = this.selectedCabinet.length ? this.selectedCabinet.filter(cabinet => cabinet.id != -1) : [];
      if (!selectedCabinet.length) return [];
      const items = [];
      selectedCabinet.forEach((cabinet) => {
        cabinet.items.forEach((item) => {
          const asset = this.assets.find((asset) => asset.cabinet_id === cabinet.id && asset.cabinet_item_number == item.number);
          const vehicle = this.vehicles.find((vehicle) => vehicle.cabinet_id === cabinet.id && vehicle.cabinet_item_number == item.number);
          const assetType = asset ? asset.asset_type : (vehicle ? 'Vehicle' : '');
          const assetName = asset ? asset.asset_name : (vehicle ? vehicle.device_name : '');
          items.push({
            cabinet,
            item,
            text: `${cabinet.name} - Item No. ${item.number}`,
            value: `${cabinet.id}-${item.number}`,
            asset_type: assetType,
            asset_name: assetName,
          });
        });
      });
      return items;
    },
    dataPerTab() {
      return this.data.filter((item) => item.cabinet.id === this.selectedCabinetTab);
    },
  },
  methods: {
    checkAllCabinet(force = false) {
      if (force) {
        if (this.textCheckAllCabinet === 'CHECK ALL CABINET') {
          this.selectedCabinet = this.cabinets;
          this.textCheckAllCabinet = 'UNCHECK ALL CABINET';
          this.iconCheckAllCabinet = 'mdi-close';
        } else {
          this.selectedCabinet = [];
          this.textCheckAllCabinet = 'CHECK ALL CABINET';
          this.iconCheckAllCabinet = 'mdi-check-all';
        }
      } else {
        if (this.selectedCabinet.length === this.cabinets.length) {
          this.textCheckAllCabinet = 'UNCHECK ALL CABINET';
          this.iconCheckAllCabinet = 'mdi-close';
        } else {
          this.textCheckAllCabinet = 'CHECK ALL CABINET';
          this.iconCheckAllCabinet = 'mdi-check-all';
        }
      }
    },
    checkAllCabinetItem(force = false) {
      if (force) {
        if (this.textCheckAllCabinetItem === 'CHECK ALL CABINET ITEM') {
          this.selectedCabinetItem = this.cabinetItems;
          this.textCheckAllCabinetItem = 'UNCHECK ALL CABINET ITEM';
          this.iconCheckAllCabinetItem = 'mdi-close';
        } else {
          this.selectedCabinetItem = [];
          this.textCheckAllCabinetItem = 'CHECK ALL CABINET ITEM';
          this.iconCheckAllCabinetItem = 'mdi-check-all';
        }
      } else {
        if (this.selectedCabinetItem.length === this.cabinetItems.length) {
          this.textCheckAllCabinetItem = 'UNCHECK ALL CABINET ITEM';
          this.iconCheckAllCabinetItem = 'mdi-close';
        } else {
          this.textCheckAllCabinetItem = 'CHECK ALL CABINET ITEM';
          this.iconCheckAllCabinetItem = 'mdi-check-all';
        }
      }
    },
    generateReport(cabinetId) {
      this.isLoading = true;
      this.data = [];
      setTimeout(() => {
        this.selectedCabinetForTabs = Object.assign([], this.selectedCabinet);
        this.data = this.cabinetItems.filter((item) => {
          if (this.selectedCabinetItem.length) {
            return this.selectedCabinetItem.find((selected) => selected.value === `${item.cabinet.id}-${item.item.number}`);
          }
          return true;
        });
        this.isLoading = false;
        this.isGenerate = true;
        if (typeof cabinetId !== 'object') {
          this.selectedCabinetTab = cabinetId;
        } else {
          this.selectedCabinetTab = this.selectedCabinet[0].id;
          this.$nextTick(() => {
            this.$refs[`tab-${this.selectedCabinetTab}`][0].$el.click();
          });
        }
        this.paginationOptions.page = 1
      }, 1000);
    },
  },
};
</script>
